module.exports = __webpack_public_path__ + "static/media/door.732d3451.mtl";